// 📂 lib/routes.ts

export const ROUTES = {
  PAGE: {
    ROOT: '/',
    LOGIN: '/login',
    CREATE_ACCOUNT: '/crear-cuenta',
  },

  DASHBOARD: {
    PRINCIPAL: '/app',
  },

  EMPLOYEES: {
    ROOT: '/app/empleados',
    CREATE: '/app/empleados/crear',
    DETAIL: (id: string) => `/app/empleados/${id}`,
    SETTLEMENT: (id: string) => `/app/empleados/${id}/liquidar`,
  },

  PAYROLL: {
    ROOT: '/app/nomina',
    CREATE: '/app/nomina/nueva',
    DETAIL: (id: string) => `/app/nomina/${id}`,
    HISTORY: '/app/nomina/historial',
  },

  FINANCES: {
    ROOT: '/app/finanzas',
    EXPENSES: '/app/egresos',
    BALANCE: '/app/balances',
  },

  REPORTS: {
    ROOT: '/app/reportes',
  },

  PROFILE: {
    ROOT: '/app/perfil',
  },

  SETTINGS: {
    ROOT: '/app/configuracion',
    FINANCE: '/app/configuracion/finanzas',
    PAYMENTS_FROM_PLAN: '/app/configuracion/pagos-plan',
  },
} as const;
